import React from 'react';
import { LoadingSpinner } from 'vetrf-ui';
import { EaeuInfo } from 'api/eaeu/types';

type TransactionItemsProps = {
  transactions: EaeuInfo['transactionType'][];
  loading: boolean;
};

export const AvailableTransactions = ({ transactions, loading }: TransactionItemsProps) => (
  <div>
    Доступны для передачи:{' '}
    {loading ? (
      <div className="d-inline">
        <LoadingSpinner color="dark" icon="spinner" spin="spin" text="" />
      </div>
    ) : (
      <>
        {transactions?.length ? (
          transactions.map(({ code, name }, i, arr) => (
            <div key={code} className="red d-inline" title={name.split('(')[0]}>
              {code + (i === arr?.length - 1 ? '' : ', ')}
            </div>
          ))
        ) : (
          <div className="red d-inline">Нет</div>
        )}
      </>
    )}
  </div>
);
